import cache from '@/lib/utils/cache';
import fetch from '@/lib/api/clients/fetchInvestmentAccount';

export function init(getFromCache, fetch) {
  return (accountId, startDate) => (
    getFromCache(
      `${accountId}/${startDate}`,
      () => fetch(accountId, startDate),
    )
  );
}

export default init(cache(), fetch.execute);
